import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { COOKIE_KEY } from 'src/constants';
import CookieStore from 'src/utils/cookie';
import * as AuthUtils from 'src/utils/auth';
import useAuth from 'src/hooks/useAuth';
import { isLoggedSelector } from 'src/selectors/auth';
import { Element } from 'src/components';

interface IProps {
    ActionComponent?: ({
        onClick,
    }: {
        onClick: any;
    }) => React.ReactElement<any>;
    onClickFn: () => void;
    children?: React.ReactNode;
    className?: string;
    renderAs?: string;
}

export const RequireLoginButton = ({
    onClickFn,
    children,
    className,
    renderAs = 'span',
}: IProps) => {
    const isLogged = useSelector(isLoggedSelector);
    const { auth } = useAuth();

    const loginCallback = () => {
        auth();
        if (onClickFn) {
            onClickFn();
        }
    };

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            if (isLogged) {
                onClickFn();
            } else {
                CookieStore.set(COOKIE_KEY.BM_CLICK_LOGIN, true);
                AuthUtils.login(loginCallback);
            }
        },
        [isLogged, onClickFn]
    );

    return (
        <Element
            renderAs={renderAs}
            onClick={handleClick}
            className={className}
        >
            {children}
        </Element>
    );
};
